import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'inrNumWords'
})
export class InrNumWordsPipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {

    if (value !== null) {
      let filteredAmount = '';
      if (isNaN(value)) {
        filteredAmount = value;
      } else {
        if (Math.abs(value) > 9999999) {
          filteredAmount =(Math.abs(value) / 10000000).toFixed(2) + ' cr';
        } else if (Math.abs(value) > 99999) {
          filteredAmount =(Math.abs(value) / 100000).toFixed(2) + ' lakh';
        } else if (Math.abs(value) > 999) {
          filteredAmount = (Math.abs(value) / 1000).toFixed(2) + ' k';
        } else {
          filteredAmount = (Math.sign(value) * Math.abs(value)) + '';
        }
      }

      return `₹ ${filteredAmount}`;
    }
  }

}
